var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.18151 20.1206C1.63305 20.1206 1.18096 19.6427 1.11914 19.027L1.11197 18.8827V10.8364C1.11197 8.52326 2.6781 6.63362 4.65 6.5102L4.85535 6.50376L18.8502 6.50376L15.3292 2.42751C14.9437 1.98125 14.914 1.27912 15.2402 0.793498L15.3292 0.676889C15.7148 0.23063 16.3214 0.19634 16.741 0.573896L16.8418 0.676889L22.1895 6.86634C22.2273 6.91016 22.2617 6.95646 22.2927 7.00474L22.3694 7.14239L22.4265 7.28203L22.4644 7.41238L22.4909 7.55783L22.4985 7.63049L22.5027 7.74165L22.4997 7.83474L22.4811 7.9901L22.4495 8.128L22.4025 8.26553L22.3466 8.38622L22.2784 8.50036L22.1895 8.61697L16.8418 14.8064C16.4241 15.2899 15.7469 15.2899 15.3292 14.8064C14.9437 14.3602 14.914 13.658 15.2402 13.1724L15.3292 13.0558L18.8502 8.97955L4.85535 8.97955C4.02143 8.97955 3.33618 9.71597 3.25843 10.6575L3.25105 10.8364V18.8827C3.25105 19.5663 2.77221 20.1206 2.18151 20.1206Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.3208,
    height: 22.3208,
    fill: "white",
    transform: "translate(22.9677 22.6351) rotate(180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow Right.42eb16db5e08ef17b2cce11777c2c376.svg";
export { ForwardRef as ReactComponent };